import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_URL || 'https://vakra.co.in/api';

function AdminSignup() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    role: 'sub_admin',
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const validateForm = () => {
    if (!formData.name.trim()) return 'Name is required.';
    if (!formData.email.trim()) return 'Email is required.';
    if (!/\S+@\S+\.\S+/.test(formData.email)) return 'Enter a valid email address.';
    if (!formData.password) return 'Password is required.';
    if (formData.password.length < 6) return 'Password must be at least 6 characters.';
    if (formData.password !== formData.confirmPassword) return 'Passwords do not match.';
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      setLoading(true);

      const payload = {
        name: formData.name.trim(),
        email: formData.email.trim().toLowerCase(),
        password: formData.password,
        role: formData.role,
      };

      const res = await axios.post(`${apiUrl}/admin/signup`, payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      setMessage(
        res?.data?.message ||
          'Admin signup request submitted successfully. Please wait for approval.'
      );

      setFormData({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        role: 'sub_admin',
      });

      setTimeout(() => {
        navigate('/admin/login');
      }, 1500);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          'Admin signup failed.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Admin Signup</h2>
        <p style={styles.subtitle}>
          Sirf approved admin hi admin panel access kar sakta hai.
        </p>

        {message ? <div style={styles.success}>{message}</div> : null}
        {error ? <div style={styles.error}>{error}</div> : null}

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
            style={styles.input}
          />

          <input
            type="email"
            name="email"
            placeholder="Admin Email"
            value={formData.email}
            onChange={handleChange}
            style={styles.input}
          />

          <select
            name="role"
            value={formData.role}
            onChange={handleChange}
            style={styles.input}
          >
            <option value="sub_admin">Sub Admin</option>
            <option value="admin">Admin</option>
          </select>

          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            style={styles.input}
          />

          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={formData.confirmPassword}
            onChange={handleChange}
            style={styles.input}
          />

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Submitting...' : 'Create Admin Account'}
          </button>
        </form>

        <div style={styles.footerText}>
          Already have admin access? <Link to="/admin/login">Login here</Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f4f6f8',
    padding: '20px',
  },
  card: {
    width: '100%',
    maxWidth: '420px',
    background: '#fff',
    padding: '28px',
    borderRadius: '14px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
  },
  title: {
    margin: '0 0 8px 0',
    textAlign: 'center',
  },
  subtitle: {
    margin: '0 0 20px 0',
    textAlign: 'center',
    color: '#666',
    fontSize: '14px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  input: {
    padding: '12px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontSize: '14px',
  },
  button: {
    padding: '12px',
    borderRadius: '8px',
    border: 'none',
    background: '#111827',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: '600',
  },
  success: {
    background: '#e7f8ec',
    color: '#166534',
    padding: '10px',
    borderRadius: '8px',
    marginBottom: '14px',
    fontSize: '14px',
  },
  error: {
    background: '#fde8e8',
    color: '#b91c1c',
    padding: '10px',
    borderRadius: '8px',
    marginBottom: '14px',
    fontSize: '14px',
  },
  footerText: {
    marginTop: '16px',
    textAlign: 'center',
    fontSize: '14px',
  },
};

export default AdminSignup;
